export default "__VITE_ASSET__CK$AxKZK__"